// @ts-nocheck
import { createSharing, uniifyInvite } from 'actions/access';

export const pensionsInfoInviteScope = { type: 'self', basic: { all: true }, pension: { all: true } };

const getFirstName = (name = '') => name?.trim()?.split(' ')[0] || '';

export const buildPensionsInfoSharingData = ({ recipient, initiator, message }) => ({
    recipient: {
        name: recipient.name,
        email: recipient.email,
        firstName: recipient.firstName || getFirstName(recipient.name),
    },
    initiator,
    requestedScopes: [pensionsInfoInviteScope],
    message,
    type: 'pensionsinfo',
});

export const sendPensionsInfoInvite = async ({ dispatch, organisationId, userId, recipient, initiator, message }) => {
    if (userId) {
        await dispatch(uniifyInvite(organisationId, userId));
    }

    const sharing = await dispatch(createSharing(organisationId, buildPensionsInfoSharingData({ recipient, initiator, message })));
    if (!sharing?.sharingId) throw new Error('bad');

    return sharing;
};
